import script from "./MembersActionDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./MembersActionDropdown.vue?vue&type=script&setup=true&lang=js"

import "./MembersActionDropdown.vue?vue&type=style&index=0&id=d2bc45c6&lang=css"

const __exports__ = script;

export default __exports__